import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const TABLE_BODY_CLASS_NAME = 'TableBody';

export const TABLE_BODY_CLASS_SLOTS = ['root'] as const;

export type TableBodyClassSlot = (typeof TABLE_BODY_CLASS_SLOTS)[number];

export interface TableBodyClasses {
	root: string;
}

export type TableBodyClassKey = keyof TableBodyClasses;

export const getTableBodyUtilityClass = (slot: string) =>
	generateUtilityClass(TABLE_BODY_CLASS_NAME, slot);

export const tableBodyClasses = generateUtilityClasses<keyof TableBodyClasses>(
	TABLE_BODY_CLASS_NAME,
	['root'],
);
export default tableBodyClasses;
